




import React, { useState } from 'react';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import present from "../assets/StatusIcons/present.svg";
import absent from "../assets/StatusIcons/absent.svg";
import earlyout from "../assets/StatusIcons/earlyout.svg";
import leave from "../assets/StatusIcons/leave.svg";
import late from "../assets/StatusIcons/late.svg";
import halfleave from "../assets/StatusIcons/halfleave.svg";
import task from "../assets/StatusIcons/task.svg";
import active from '../assets/Dashboard/active.svg';
import inactive from '../assets/Dashboard/inactive.svg';
import trial from '../assets/Dashboard/trial.svg';
import invited from '../assets/Dashboard/invited.svg';
import request from '../assets/Dashboard/request.svg';
import process from "../assets/Dashboard/process.svg";
import overdue from "../assets/Dashboard/overdue.svg";
import received from "../assets/Wallet/received.svg";
import pending from "../assets/Wallet/pending.svg";
import { useTranslation } from 'react-i18next';
import valid from "../assets/Attendance/valid.svg"
import i18n from 'i18next';
import cancel from "../assets/StatusIcons/cancel.svg";
import expire from "../assets/StatusIcons/expire.svg";
import tobepaid from "../assets/StatusIcons/tobepaid.svg";
import close from "../assets/Dashboard/close.svg";
import open1 from "../assets/Dashboard/open1.svg";
import reopen from "../assets/Dashboard/reopen.svg";
import { statusStyles } from "../constants/statusPalette";

/**
 * Draws the SVG asset in `currentColor` so icon matches badge text (same hue as palette).
 * Plain <img> ignores color and keeps baked-in SVG fills.
 */
const StatusGlyphIcon = ({ src, size = 20 }) => {
  if (!src) return null;
  return (
    <Box
      component="span"
      aria-hidden
      sx={{
        display: 'inline-block',
        width: size,
        height: size,
        flexShrink: 0,
        bgcolor: 'currentColor',
        maskImage: `url(${src})`,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskImage: `url(${src})`,
        WebkitMaskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
      }}
    />
  );
};

const StatusDropdown = ({ currentStatus, onChange,statusOptions = [], labelMap = {}  }) => {
  const { t, i18n } = useTranslation();

//   console.log('🌐 Language:', i18n.language);
// console.log('🔑 Translated status:', t(`status.${currentStatus}`));
const statusIcons = {
  Present: present,
  CLOCK_IN: present,
  PRESENT: present,
  ON_TIME_CLOCK_IN: present,
  ON_TIME_CLOCK_OUT: present,
cancelled: cancel,
CANCELLED: cancel,

expired: expire,
   revoked: cancel,
   Validated: present,
  Paid:present,
    paid:present,
 new: invited,
  closed:close,
      open:open1,
       reopened:reopen,
  completed: present,
 Verified: present,
  verified: present,
    Approved: present,
        approved: present,
                APPROVED: present,


  Absent: absent,
  Invalid:absent,
 Error: absent,
  Delayed: absent,
   Rejected: absent,
      REJECTED: absent,

      rejected: absent,

  UNDER_REVIEW: request,
  'Under Review': request,
  under_review: request,
  underReview: request,

  Leave: leave,
  assigned: leave,
  Pending:halfleave,
    email_pending:leave,
    ON_LEAVE:halfleave,
    ON_HALF_LEAVE:halfleave,
INFO_REQUESTED:open1,  // Different icon for Request Info
REQUEST_INFO:open1,    // Different icon for Request Info
    pending:halfleave,
    PENDING:halfleave,

    valid:valid,
  'Early Out': earlyout,  
    Ongoing: earlyout,      // ✅ Use quotes because of the space
  'Late Arrival': late,
  LATE_ARRIVAL: late,
  'ON_BREAK':late,
  BREAK: late,
   'in_progress': halfleave,
  'Half Leave': halfleave,
   Paused: halfleave,
    'Requested': halfleave,
        'Request': halfleave,
        toBePaid: tobepaid,
    Active: present,
      active: present,
        sent: present,
  Invited: invited,
    invited: invited,
    Requested: request,
     Inactive: inactive,
          inactive: inactive,

     high:task,
     medium:task,
     urgent:task,
     low:task,
     CHECKED_OUT:absent,
     CLOCK_OUT:absent,
     EARLY_CLOCK_OUT:earlyout,
     EARLY_CLOCK_IN: present,
     LATE_CLOCK_OUT:late,
     ABSENT:absent,
     not_done:absent,
     BACK_FROM_BREAK:halfleave,
     BREAK_END:halfleave,
     BREAK_START:late,
       escalated:inactive,
        resolved: active,

};

const canOpenDropdown = Object.keys(statusStyles).filter(
  status => status !== '' && status !== 'Received'
);
const showDropdownIcon = ['', '', '', '','',''];
const allStatuses = Object.keys(statusStyles);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    if (canOpenDropdown.includes(currentStatus)) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = (status) => {
    if (status) onChange(status);
    setAnchorEl(null);
  };
  const displayStatusLabels = {
  initiated: 'Processing',
  success: 'Paid',
  failed: 'Failed',
  // Add other overrides if needed
};
const getStatusLabel = (status) => {
  if (labelMap && labelMap[status]) {
    return t(labelMap[status]);
  }
  return t(`statuses.${displayStatusLabels[status] || status}`);
};

  return (
    <>
      {/* <Box
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          px: 0.4,
          pr:0.6,
          py: 0.4,
          borderRadius: '4px',
          fontWeight: 400,
          fontFamily: 'Poppins, sans-serif',
          fontSize: '13px',
          cursor: canOpenDropdown.includes(currentStatus) ? 'pointer' : 'default',
          width: 'fit-content',
          cursor:"pointer",
              whiteSpace: 'nowrap',         // ✅ no line break

          ...statusStyles[currentStatus]
        }}
      > */}
<Box
  onClick={handleClick}
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    px: 1,
    py: 0.4,
    borderRadius: "6px",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    cursor: canOpenDropdown.includes(currentStatus) ? "pointer" : "default",

    // 🌍 Responsive equal width logic
    flex: 1,                            // take full space inside table cell
    maxWidth: i18n.language === "es" ? 220 : 150,                      // prevent overflow
    minWidth: 125,                      // ensure equal base size
    width: "100%",                      // allow auto-fit

    ...statusStyles[currentStatus],
    // Ensure icon + label share one foreground color from palette
    color: statusStyles[currentStatus]?.color || '#333333',
  }}
>
        <StatusGlyphIcon src={statusIcons[currentStatus]} size={20} />

        <Typography
          sx={{
            fontSize: '13px',
            fontFamily: 'Poppins, sans-serif',
            color: 'inherit',
            minWidth: 0,
            textAlign: 'center',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {getStatusLabel(currentStatus)}
        </Typography>
        {showDropdownIcon.includes(currentStatus) && (
          <ArrowDropDownIcon sx={{ fontSize: 18, color: 'inherit' }} />
        )}
      </Box>

      <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose(null)}>
       
        {statusOptions.map((status) => (
          <MenuItem key={status} onClick={() => handleClose(status)}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                gap: 1,
                color: statusStyles[status]?.color || '#333333',
              }}
            >
              <StatusGlyphIcon src={statusIcons[status]} size={16} />
              <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '13px', color: 'inherit' }}>
                {getStatusLabel(status)}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
export default StatusDropdown;












// import React, { useState } from 'react';
// import { Box, Menu, MenuItem, Typography } from '@mui/material';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import present from "../assets/StatusIcons/present.svg";
// import absent from "../assets/StatusIcons/absent.svg";
// import earlyout from "../assets/StatusIcons/earlyout.svg";
// import leave from "../assets/StatusIcons/leave.svg";
// import late from "../assets/StatusIcons/late.svg";
// import halfleave from "../assets/StatusIcons/halfleave.svg";
// import task from "../assets/StatusIcons/task.svg";
// import active from '../assets/Dashboard/active.svg';
// import inactive from '../assets/Dashboard/inactive.svg';
// import trial from '../assets/Dashboard/trial.svg';
// import invited from '../assets/Dashboard/invited.svg';
// import request from '../assets/Dashboard/request.svg';
// import process from "../assets/Dashboard/process.svg";
// import overdue from "../assets/Dashboard/overdue.svg";
// import received from "../assets/Wallet/received.svg";
// import pending from "../assets/Wallet/pending.svg";
// import { useTranslation } from 'react-i18next';
// import valid from "../assets/Attendance/valid.svg"
// import i18n from 'i18next';
// import cancel from "../assets/StatusIcons/cancel.svg";
// import expire from "../assets/StatusIcons/expire.svg";
// import tobepaid from "../assets/StatusIcons/tobepaid.svg";
// import close from "../assets/Dashboard/close.svg";
// import open1 from "../assets/Dashboard/open1.svg";
// import reopen from "../assets/Dashboard/reopen.svg";

// const StatusDropdown = ({ currentStatus, onChange,statusOptions = []  }) => {
//   const { t } = useTranslation();

// //   console.log('🌐 Language:', i18n.language);
// // console.log('🔑 Translated status:', t(`status.${currentStatus}`));
// const statusIcons = {
//   Present: present,
//   CLOCK_IN:present,
//    PRESENT: present,
// cancelled: cancel,
// CANCELLED: cancel,

// expired: expire,
//    Validated: present,
//   Paid:present,
//     paid:present,
//  new: invited,
//   closed:close,
//       open:open1,
//        reopened:reopen,
//   completed: present,
//  Verified: present,
//   verified: present,
//     Approved: present,
//         approved: present,
//                 APPROVED: present,


//   Absent: absent,
//   Invalid:absent,
//  Error: absent,
//   Delayed: absent,
//    Rejected: absent,
//       REJECTED: absent,

//       rejected: absent,

//   Leave: leave,
//   assigned: leave,
//   Pending:halfleave,
//     email_pending:leave,
//     ON_LEAVE:halfleave,
// INFO_REQUESTED:halfleave,
//     pending:halfleave,
//     PENDING:halfleave,

//     valid:valid,
//   'Early Out': earlyout,  
//     Ongoing: earlyout,      // ✅ Use quotes because of the space
//   'Late Arrival': late,
//   'ON_BREAK':late,
//    'in_progress': halfleave,
//   'Half Leave': halfleave,
//    Paused: halfleave,
//     'Requested': halfleave,
//         'Request': halfleave,
//         toBePaid: tobepaid,
//     Active: present,
//       active: present,
//         sent: present,
//   Invited: invited,
//     invited: invited,
//     Requested: request,
//      Inactive: inactive,
//           inactive: inactive,

//      high:task,
//      medium:task,
//      urgent:task,
//      low:task,
//      CHECKED_OUT:absent,
//      CLOCK_OUT:absent,
//      ABSENT:absent,
//      not_done:absent,
//      BACK_FROM_BREAK:halfleave,
//      BREAK_END:halfleave,
//      BREAK_START:late,
//        escalated:inactive,
//         resolved: active,

// };
// const statusStyles = {
//   CLOCK_IN:{ backgroundColor: '#4BCE97', color: '#164B35' },
//   Present: { backgroundColor: '#4BCE97', color: '#164B35' },
//  sent: { backgroundColor: '#4BCE97', color: '#164B35' },

//    PRESENT: { backgroundColor: '#4BCE97', color: '#164B35' },
//   Validated: { backgroundColor: '#4BCE97', color: '#164B35' },
//     Paid: { backgroundColor: '#4BCE97', color: '#164B35' },
//         paid: { backgroundColor: '#4BCE97', color: '#164B35' },

//   completed: { backgroundColor: '#4BCE97', color: '#164B35' },
//  Verified: { backgroundColor: '#4BCE97', color: '#164B35' },
//   verified: { backgroundColor: '#4BCE97', color: '#164B35' },
//   Approved: {   backgroundColor: '#4BA3CE',
//   color: '#163A4B', },
//     APPROVED: {    backgroundColor: '#4BA3CE',
//   color: '#163A4B', },
//   escalated: { backgroundColor: '#F87168', color: '#5D1F1A' },
//     resolved: { backgroundColor: '#4BCE97', color: '#164B35' },
//     approved: {   backgroundColor: '#4BA3CE',
//   color: '#163A4B', },
//   reopened: { backgroundColor: '#57D5FF', color: '#095C6C' },
//    closed: { backgroundColor: '#C1F2A0', color: '#215922' },
//   cancelled:{ backgroundColor: '#FEA362', color: '#702E00' },
//     CANCELLED:{ backgroundColor: '#FEA362', color: '#702E00' },

//     expired:{ backgroundColor: '#091E4224', color: '#44546F' },
//   Absent: { backgroundColor: '#F87168', color: '#5D1F1A' },
//     not_done: { backgroundColor: '#F87168', color: '#5D1F1A' },
//  CHECKED_OUT: { backgroundColor: '#F87168', color: '#5D1F1A' },
//   CLOCK_OUT: { backgroundColor: '#F87168', color: '#5D1F1A' },
//   Invalid: { backgroundColor: '#F87168', color: '#5D1F1A' },
//   Error: { backgroundColor: '#F87168', color: '#5D1F1A' },
//   Delayed: { backgroundColor: '#F87168', color: '#5D1F1A' },
//   Rejected: { backgroundColor: '#F87168', color: '#5D1F1A' },
//     REJECTED: { backgroundColor: '#F87168', color: '#5D1F1A' },

//     rejected: { backgroundColor: '#F87168', color: '#5D1F1A' },
//  new: { backgroundColor: '#579DFF', color:  '#09326C' },
//   ABSENT: { backgroundColor: '#F87168', color: '#5D1F1A' },
//   Leave: { backgroundColor: '#579DFF', color: '#09326C' },
//    INFO_REQUESTED:{ backgroundColor: '#F5CD47', color: '#533F04'},
// ON_LEAVE:{backgroundColor: '#F5CD47', color: '#533F04'},
//   assigned: { backgroundColor: '#579DFF', color: '#09326C' },
// Pending: { backgroundColor: '#F5CD47', color: '#533F04'},
// pending: {backgroundColor: '#F5CD47', color: '#533F04' },
// email_pending: { backgroundColor: '#F5CD47', color: '#533F04' },
// PENDING: {backgroundColor: '#F5CD47', color: '#533F04'},
//  open: { backgroundColor: '#F5CD47', color: '#533F04' },

//   'Early Out': { backgroundColor: '#9F8FEF', color: '#352C63' }, // ✅ Fix here
//    Ongoing: { backgroundColor: '#9F8FEF', color: '#352C63' },
//   'Late Arrival': { backgroundColor: '#FEA362', color: '#702E00' },
//     'ON_BREAK': { backgroundColor: '#FEA362', color: '#702E00' },
// BREAK_START:{ backgroundColor: '#FEA362', color: '#702E00'},
//    'in_progress': {  backgroundColor: '#F5CD47', color: '#533F04' },
//   'Half Leave': { backgroundColor: '#F5CD47', color: '#533F04' },
//    Paused: { backgroundColor: '#F5CD47', color: '#533F04' },
//       BACK_FROM_BREAK: { backgroundColor: '#F5CD47', color: '#533F04' },
//           BREAK_END: { backgroundColor: '#F5CD47', color: '#533F04' },
//    'Requested': { backgroundColor: '#F5CD47', color: '#533F04' },
//    'Request': { backgroundColor: '#F5CD47', color: '#533F04' },
//      Active: { backgroundColor: '#4BCE97', color: '#164B35' },
//           active: { backgroundColor: '#4BCE97', color: '#164B35' },
//         Invited: { backgroundColor: '#579DFF', color: '#09326C' },
//          invited: { backgroundColor: '#579DFF', color: '#09326C' },
//          toBePaid: { backgroundColor: '#579DFF', color: '#09326C' },
//          Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
//           Inactive: {   backgroundColor: '#9CA3AF',
//   color: '#374151', },
//                     inactive: {   backgroundColor: '#9CA3AF',
//   color: '#374151', },

//         low: { backgroundColor: '#BCBFC2', color: '#44546F' },
//         medium: { backgroundColor: '#579DFF', color: '#09326C' },
//        high: { backgroundColor: '#FEA362', color: '#702E00' },
//      urgent: { backgroundColor: '#F87168', color: '#5D1F1A' },
//      valid: { backgroundColor: '#579DFF', color: '#ffffff' },
// };
// const canOpenDropdown = Object.keys(statusStyles).filter(
//   status => status !== '' && status !== 'Received'
// );
// const showDropdownIcon = ['', '', '', '','',''];
// const allStatuses = Object.keys(statusStyles);

//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);
//   const handleClick = (event) => {
//     if (canOpenDropdown.includes(currentStatus)) {
//       setAnchorEl(event.currentTarget);
//     }
//   };
//   const handleClose = (status) => {
//     if (status) onChange(status);
//     setAnchorEl(null);
//   };
//   const displayStatusLabels = {
//   initiated: 'Processing',
//   success: 'Paid',
//   failed: 'Failed',
//   // Add other overrides if needed
// };
//   return (
//     <>
//       {/* <Box
//         onClick={handleClick}
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           gap: 0.5,
//           px: 0.4,
//           pr:0.6,
//           py: 0.4,
//           borderRadius: '4px',
//           fontWeight: 400,
//           fontFamily: 'Poppins, sans-serif',
//           fontSize: '13px',
//           cursor: canOpenDropdown.includes(currentStatus) ? 'pointer' : 'default',
//           width: 'fit-content',
//           cursor:"pointer",
//               whiteSpace: 'nowrap',         // ✅ no line break

//           ...statusStyles[currentStatus]
//         }}
//       > */}
// <Box
//   onClick={handleClick}
//   sx={{
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: 0.5,
//     px: 1,
//     py: 0.4,
//     borderRadius: "6px",
//     fontWeight: 500,
//     fontFamily: "Poppins, sans-serif",
//     fontSize: "13px",
//     cursor: canOpenDropdown.includes(currentStatus) ? "pointer" : "default",

//     // 🌍 Responsive equal width logic
//     flex: 1,                            // take full space inside table cell
//     maxWidth: 135,                      // prevent overflow
//     minWidth: 110,                      // ensure equal base size
//     width: "100%",                      // allow auto-fit
//     textAlign: "center",
//     whiteSpace: "nowrap",
//     overflow: "hidden",
//     textOverflow: "ellipsis",

//     ...statusStyles[currentStatus],
//   }}
// >

//         <img src={statusIcons[currentStatus]} alt={currentStatus} style={{ width: 20, height: 20 }} />
      
//         <Typography sx={{ fontSize: '13px',  fontFamily: 'Poppins, sans-serif', color: (statusStyles[currentStatus]?.color || '#333333') }}>
//   {/* {displayStatusLabels[currentStatus] || currentStatus} */}
//     {t(`statuses.${displayStatusLabels[currentStatus] || currentStatus}`)}

 

// </Typography>
//         {showDropdownIcon.includes(currentStatus) && (
//           <ArrowDropDownIcon sx={{ fontSize: 18, color: statusStyles[currentStatus].color }} />
//         )}
//       </Box>

//       <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose(null)}>
       
//         {statusOptions.map((status) => (
//   <MenuItem key={status} onClick={() => handleClose(status)}>
//     <Box sx={{ display: 'flex', alignItems: 'center',justifyContent:"space-between" }}>
//       <img src={statusIcons[status]} alt={status} style={{ width: 16, height: 16 }} />
//       <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '13px' }}>
//         {/* {status} */}
//           {t(`statuses.${status}`)}
//         </Typography>
//     </Box>
//   </MenuItem>
// ))}
//       </Menu>
//     </>
//   );
// };
// export default StatusDropdown;







